import { Anchor, Icon } from "client/Components";
import { Coordinate } from "client/Misc/commonTypes";
import { MouseEvent, ReactElement } from "react";
import styles from "./TileMenuButton.module.less";

export type TileMenuButtonProps = {
	onClick: (coordinate: Coordinate) => void;
};

export const TileMenuButton = (props: TileMenuButtonProps): ReactElement => {
	const {
		onClick
	} = props;

	const clickHandler = (ev: MouseEvent): void => {
		ev.stopPropagation();
		onClick({
			x: ev.clientX,
			y: ev.clientY
		});
	};

	return (
		<Anchor
			trackingId="context-dropdown"
			className={styles.root}
			onClick={clickHandler}
		>
			<Icon value="ellipsis" />
		</Anchor>
	);
};
TileMenuButton.displayName = "TileMenuButton";